export const getPatientFacingAppointmentName = (
  appointmentTypeName?: string
) => {
  if (!appointmentTypeName) {
    return ''
  } else {
    return `${appointmentTypeName
      .replace(/\bsecond\b/i, '')
      // clean up Nutrition Follow Up Visit, Nutrition Only Follow Up Visit & Follow Up Medical Visit
      .replace(/\bfollow up\b/i, '')
      // for nutrition only visits, we never want the patient to see "only"
      .replace(/\bonly\b/i, '')
      .trim()}`
  }
}
